"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
;
var useAsync = function (fn, args) {
    var _a = react_1.useState({
        loading: true
    }), state = _a[0], set = _a[1];
    var memoized = react_1.useCallback(fn, args);
    react_1.useEffect(function () {
        var mounted = true;
        set({
            loading: true
        });
        var promise = memoized();
        promise.then(function (value) {
            if (mounted) {
                set({
                    loading: false,
                    value: value
                });
            }
        }, function (error) {
            if (mounted) {
                set({
                    loading: false,
                    error: error
                });
            }
        });
        return function () {
            mounted = false;
        };
    }, [memoized]);
    return state;
};
exports.default = useAsync;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useAsync.js
// module id = 426
// module chunks = 17